/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e){super(r,"ivec2",1,(o,s,t)=>o.setUniform2iv(r,e(s,t)))}}export{e as Integer2PassUniform};
